module.exports = __webpack_public_path__ + "img/obs_water_fldctl_down.abf5e646.svg";